import { render, staticRenderFns } from "./duHome.vue?vue&type=template&id=ba804d54&"
import script from "./duHome.vue?vue&type=script&lang=js&"
export * from "./duHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports